import { debounce } from '@archetype-themes/utils/utils'

class ToolTipTrigger extends HTMLElement {
  constructor() {
    super()
    this.el = this
    this.toolTipContent = this.querySelector('[data-tool-tip-trigger-content]')

    // If quick view or quick add, trigger on the grid item so we
    // can preload data as soon as we hover or focus on it
    this.trigger = this.dataset.toolTip.includes('Quick') ? this.el.closest('[data-product-grid-item]') : this.el

    this.init();
     setTimeout(() => {
        const VarPrice1 = this.querySelector("button")?.dataset.price;
        this.updateRewardPoints(VarPrice1);
      }, 500);
  }
  updateRewardPoints(varPrice) {
    const pointsContainer = document.querySelector(".template-collection .product__points");
    if (pointsContainer) {
      const originalText = pointsContainer?.textContent || "";

      const valuePattern = /\bX\b|\b\d+(\.\d+)?\b/;

      if (valuePattern.test(originalText)) {
        if (varPrice) {
          const variantPrice = varPrice / 100;
          const rewardPointsValue = variantPrice * 5;

          const newText = originalText.replace(valuePattern, rewardPointsValue);
          pointsContainer.textContent = newText;
        }
      }
    }
  }
  init() {
    const toolTipOpen = new CustomEvent('tooltip:open', {
      detail: {
        context: this.dataset.toolTip,
        content: this.toolTipContent?.innerHTML,
        tool_tip_classes: this.dataset.toolTipClasses
      },
      bubbles: true
    })

    const toolTipInteract = new CustomEvent('tooltip:interact', {
      detail: {
        context: this.dataset.toolTip,
        content: this.toolTipContent?.innerHTML,
        tool_tip_classes: this.dataset.toolTipClasses
      },
      bubbles: true
    })

    const debouncedMouseOverHandler = debounce(
      500,
      (e) => {
        e.stopPropagation()
        this.dispatchEvent(toolTipInteract)
      },
      true
    )

    const debouncedFocusInHandler = debounce(500, (e) => {
      e.stopPropagation()
      this.dispatchEvent(toolTipInteract)
    })

    this.trigger.addEventListener('mouseover', debouncedMouseOverHandler)

    this.trigger.addEventListener('focusin', debouncedFocusInHandler)

    this.el.addEventListener('click', (e) => {
      e.stopPropagation()
      this.dispatchEvent(toolTipOpen);
         setTimeout(() => {
        const VarPrice = this.querySelector("button")?.dataset.price;
        this.updateRewardPoints(VarPrice);
      }, 500);
    })
  }
}

customElements.define('tool-tip-trigger', ToolTipTrigger)
